<template>
    <div class="sidebar">
        <button id='sideMenuButton' v-if=!IsDesktopScreen :class="{IsActive : !IsDesktopScreen}" v-on:click=Toggle>Menu</button>
        <div class="sideMenuBarContent" :class="{sideBarActive : Show}">
            <div id="space"></div>
            <ScrambleTextLink @click=handleNavigation linkTo="/" msg="About Me" />
            <ScrambleTextLink @click=handleNavigation linkTo="/performances" msg="Performances" />
            <ScrambleTextLink @click=handleNavigation linkTo="/development" msg="Audio Programming" />
            <ScrambleTextLink @click=handleNavigation linkTo="/soundDesign" msg="Sound Design" />
            <ScrambleTextLink @click=handleNavigation linkTo="/music" msg="Music" />
        </div>
    </div>
</template>

<script>
    import ScrambleTextLink from './ScrambleTextLink.vue'

    export default {
        name: 'SideMenu',
        data() {
            return {
                Show: window.innerWidth >= 768,
                IsDesktopScreen: window.innerWidth >= 768
            }
        },
        components: {
            ScrambleTextLink
        },
        methods: {
            Toggle: function () {
                this.Show = !this.Show
            },
            checkScreenSize() {
                this.IsDesktopScreen = window.innerWidth >= 768; // Adjust the breakpoint as needed
            },
            handleNavigation() {
                // Only toggle sidebar on mobile
                if (!this.IsDesktopScreen) {
                    this.Show = false;
                }
                // Actual navigation now handled in ScrambleTextLink
            }
        },
        mounted() {
            this.checkScreenSize(); // Initial check
            window.addEventListener('resize', this.checkScreenSize); // Listen for resize events
        },
        beforeUnmount() {
            window.removeEventListener('resize', this.checkScreenSize); // Clean up the event listener
        }
    }
</script>

<style>
    #sideMenuButton {
        font-family: 'Roboto Mono';
        background: white;
        border: none;
        outline: none;
        padding: 12px;
        transition: 0.2s;
    }

    .IsActive {
        /* border-bottom: 0.5px solid black !important; */
        transition: 0.4s;
    }



 @media (min-width: 768px) {
    .sideBarActive {
        transition: 1s ease-out;
        border-right: 1px solid black;
    }

    #space {
        height: 3rem;
    }
    .sidebar {
        color: black;
        position: fixed;
        top: 0rem;
        left: 0rem;
        transition: 0.5s;
        z-index: 99999;
        padding: 1rem;
    }

    .sideMenuBarContent {
        position: fixed;
        top: 5rem;
        transition: 1s ease-out;
        width: 13rem;
        height: 70vh;
    }
  }

   @media (max-width: 767px) {
    .sideBarActive {
        transition: 1s ease-out;
        transform: translateX(23rem);
    }

    .sidebar {
        color: black;
        position: fixed;
        top: 0rem;
        left: 0rem;
        transition: 0.5s;
        z-index: 99999;
        padding: 1rem;
    }

    .sideMenuBarContent {
        position: fixed;
        top: 5rem;
        left: -23rem;
        transition: 1s ease-out;
        width: 50%;
        border-right: 0.0px solid black;
        height: 70vh;
        background: white;
        padding-left: 1.2rem;
    }
  }
</style>